import { observer } from "mobx-react";
import { useState } from "react";

import ActivityList from "./ActivityList/ActivityList";
import MarketItem from "../MarketItem/MarketItem";

import { ENABLED_MARKETS } from "AppStore";

import { getCountPlatforms } from "utils/helpers";

import "./ServicesSection.scss";

const platformCount = ENABLED_MARKETS.length;

const ServicesSection = observer(({ store, isMobile }) => {
  const [animateActivityList, setAnimateActivityList] = useState(false);

  const handleMarketSelect = (marketId) => {
    setAnimateActivityList(true);
    const fullStoreIndex = store.marketStores.findIndex(
      marketStore => marketStore.market.id === marketId
    );
    if (fullStoreIndex !== -1) {
      store.selectMarketStoreByIndex(fullStoreIndex);
    }
    setTimeout(() => setAnimateActivityList(false), 300);
  };

  const getCurrentSelectedIndex = () => {
    const currentMarketId = store.currentMarketStore?.market?.id;
    return ENABLED_MARKETS.findIndex(market => market.id === currentMarketId);
  };

  return (
    <section className="main__services">
      <div className="main__services_platforms">
        <div className="main__services_platforms-market">
          {ENABLED_MARKETS.map((market, index) => (
            <MarketItem
              key={index.id}
              market={market}
              index={index}
              onClick={() => handleMarketSelect(market.id)}
              isSelected={index === getCurrentSelectedIndex()}
              containerClassName="main__services_platforms-items"
              itemClassName="main__services_platforms-item"
              logoClassName="main__services_platforms-logo"
              titleClassName="main__services_platforms-title"
            />
          ))}
        </div>
        <p className="main__services_platforms-content">
          <span>Уже доступно</span>
          <i>{platformCount} {getCountPlatforms(platformCount)}</i>
          <span className="main__services_platforms-content-more">
            Но будет еще больше!
          </span>
        </p>
      </div>
      <ActivityList store={store} isMobile={isMobile} animate={animateActivityList} />
    </section>
  );
});

export default ServicesSection;
